import React from "react";
import { Link, graphql } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";

class TagRoute extends React.Component {
  render() {
    const posts = this.props.data.allKdccmsNews.edges;
    const tag = this.props.pageContext.tag;
    const title = this.props.data.site.siteMetadata.title;
    const totalCount = this.props.data.allKdccmsNews.totalCount;
    const tagHeader = `${totalCount} post${
      totalCount === 1 ? "" : "s"
    } tagged with “${tag}”`;

    return (
      <Layout>
        <SEO
          title={`${tag} | News | ${title}`}
          keywords={[
            "news",
            "tags",
            "electrical",
            "Philippines",
            "design",
            "build",
            "system",
            "supply",
            "troubleshoot",
            "repair",
            "equipments",
            "test",
            "manage",
            "bms"
          ]}
        />
        <div className="container space-2 space-3-top--lg">
          <h1>{tagHeader}</h1>
        </div>
        <div className="container space-3-bottom--lg">
          <div className="row">
            <div className="col-lg-12 mb-9 mb-lg-0">
              <div className="card-mb card-sm-columns card-sm-3-count">
                {posts &&
                  posts.map(({ node: post }) => (
                    <article className="card mb-3" key={post.id}>
                      {post.bannerImage ? (
                        <PreviewCompatibleImage
                          imageInfo={{
                            image: post.bannerImage,
                            alt: `featured image thumbnail for post ${post.title}`,
                            className: "card-img-top"
                          }}
                        />
                      ) : null}
                      {/* <img className="card-img-top" src="../../assets/img/500x250/img11.jpg" alt="Image Description" /> */}
                      <div className="card-body p-5">
                        <small className="d-block text-muted mb-2">
                          {post.publishDate}
                        </small>
                        <h3 className="h5">
                          <Link className="button" to={`/news/${post.slug}`}>
                            {post.title}
                          </Link>
                        </h3>
                        <p>{post.description}</p>
                      </div>
                    </article>
                  ))}
              </div>
            </div>
          </div>
          <p>
            <Link to="/news/">Back to Latest News</Link>
          </p>
        </div>
      </Layout>
    );
  }
}

export default TagRoute;

export const tagPageQuery = graphql`
  query TagPage($regex: String) {
    site {
      siteMetadata {
        title
      }
    }
    allKdccmsNews(
      limit: 1000
      sort: { fields: [publishDate], order: DESC }
      filter: { tags: { regex: $regex } }
    ) {
      totalCount
      edges {
        node {
          id
          slug
          title
          publishDate(formatString: "MMMM DD, YYYY")
          description
          bannerImage {
            childImageSharp {
              fluid(maxWidth: 403, quality: 90) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
